<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'
import { fetchPdfPage } from '../api'

const props = defineProps<{ url?: string; pages?: number }>()
const pageUrls = ref<string[]>([])
const loading = ref(false)
const error = ref('')
let request: AbortController | null = null
function cleanup() {
  request?.abort()
  pageUrls.value.forEach(URL.revokeObjectURL)
  pageUrls.value = []
}
async function load() {
  cleanup()
  error.value = ''
  loading.value = false
  if (!props.url) return
  const active = new AbortController()
  request = active
  loading.value = true
  try {
    const pageCount = Math.max(1, Math.min(Number(props.pages) || 1, 100))
    const base = props.url.replace(/\/pdf$/, '')
    for (let page = 1; page <= pageCount; page += 1) {
      const blob = await fetchPdfPage(`${base}/pages/${page}.png`, active.signal)
      if (active.signal.aborted) return
      pageUrls.value.push(URL.createObjectURL(blob))
    }
  } catch (e) {
    if (!active.signal.aborted) error.value = e instanceof Error ? e.message : 'PDF 加载失败'
  } finally {
    if (!active.signal.aborted) loading.value = false
  }
}
watch(() => [props.url, props.pages], load, { immediate: true })
onBeforeUnmount(cleanup)
</script>

<template>
  <section class="event-pdf-preview">
    <div v-if="loading" class="empty" role="status">正在加载网页留存 PDF…</div>
    <div v-else-if="error" class="empty" role="alert">{{ error }} <button class="secondary" @click="load">重试</button></div>
    <template v-else-if="pageUrls.length">
      <img v-for="(pageUrl, index) in pageUrls" :key="pageUrl" :src="pageUrl" :alt="`网页留存第 ${index + 1} 页`" />
    </template>
    <div v-else class="empty">此文章尚未生成网页 PDF，请在时事内容管理中补生成。</div>
  </section>
</template>

<style scoped>
.event-pdf-preview img { display:block; width:100%; height:auto; margin:0 auto; border:1px solid var(--line, #dce5ef); border-radius:0; background:#fff; }
</style>
